import type { Dispatch, SetStateAction } from 'react'
import type { useI18n } from '../../../i18n'
import type { AdminAccount } from '../../../types'
import type { AdminHeadersGetter } from './types'
import { useProfileSecurityPasswordActions } from './useProfileSecurityPasswordActions'
import { useProfileSecurityPasskeyActions } from './useProfileSecurityPasskeyActions'
import { useProfileSecurityTwoFactorActions } from './useProfileSecurityTwoFactorActions'

type UseProfileSecurityActionsParams = {
  token: string | null
  authHeaders: AdminHeadersGetter
  t: ReturnType<typeof useI18n>['t']
  setAccount: Dispatch<SetStateAction<AdminAccount | null>>
  ensureAuthenticated: () => boolean
}

export const useProfileSecurityActions = ({
  token,
  authHeaders,
  t,
  setAccount,
  ensureAuthenticated,
}: UseProfileSecurityActionsParams) => {
  const passwordActions = useProfileSecurityPasswordActions({
    token,
    authHeaders,
    t,
    setAccount,
    ensureAuthenticated,
  })
  const twoFactorActions = useProfileSecurityTwoFactorActions({
    token,
    authHeaders,
    t,
    setAccount,
    ensureAuthenticated,
  })
  const passkeyActions = useProfileSecurityPasskeyActions({
    authHeaders,
    t,
    ensureAuthenticated,
  })

  return {
    ...passwordActions,
    ...twoFactorActions,
    ...passkeyActions,
  }
}
